import React, {useEffect, useMemo, useState} from "react"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import useWindowSize from "../../../../../hooks/useWindowSize"
import {IFetchOrdersParams} from "../../../../../models/order"
import {fetchOrders, setCurrentPage} from "../../../../../store/actions/orderActions"
import OrderLine from "../OrderLine"
import {IDataTableTitle} from "../../../../../models"
import Loading from "../../../Loading/Loading"
import Pagination from "../../../../generic/navigation/Pagination"
import ModalSuccess from "../../../modals/ModalSuccess/ModalSuccess"
import classes from "./OrderList.module.scss"

interface IOrderListProps {
  className?: string
  searchQuery?: string
}

function OrderList ({className, searchQuery}: IOrderListProps) {

  const dispatch = useAppDispatch()
  const windowSize = useWindowSize()
  const {list, isLoading, totalCount, pages, pageSize, filters, currentPage} = useAppSelector(state => state.order)
  const [modalEditSuccessShown, modalEditSuccessToggle] = useState(false)
  const [modalCopySuccessShown, modalCopySuccessToggle] = useState(false)

  const pageChangeHandler = ({selected}: {selected: number}) => {
    dispatch(setCurrentPage(selected + 1))
  }

  useEffect(() => {
    dispatch(setCurrentPage(1))
  }, [filters, dispatch])

  const fetchParams = useMemo(() => {

    const obj: IFetchOrdersParams = {}

    obj.page = currentPage
    obj.pageSize = pageSize

    if (searchQuery) {
      obj.query = searchQuery
    }

    return {...obj, ...filters}

  }, [
    currentPage,
    pageSize,
    searchQuery,
    filters
  ])

  useEffect(() => {
    dispatch(fetchOrders(fetchParams))
  },[
    dispatch,
    fetchParams
  ])

  const titles: IDataTableTitle[] = [
    {
      id: 1,
      name: "Дата и время прибытия"
    },
    {
      id: 2,
      name: "Откуда"
    },
    {
      id: 3,
      name: "Куда"
    },
    {
      id: 4,
      name: "ФИО клиента"
    },
    {
      id: 5,
      name: "Телефон клиента"
    },
    {
      id: 6,
      name: "Бригада"
    },
    {
      id: 7,
      name: "Стоимость"
    },
    {
      id: 8,
      name: "Способ оплаты"
    },
    {
      id: 9,
      name: "№ заявки"
    },
    {
      id: 10,
      name: "Статус",
      className: classes.data_cell_status
    },
    {
      id: 11,
      name: "",
      className: classes.data_cell_menu
    },
  ]

  const headerFieldsTemplate = titles.map((item) => {

    const cellCls = [classes.data_cell]

    if (item.className) {
      cellCls.push(item.className)
    }

    return (
      <div
        className={cellCls.join(" ")}
        key={item.id}
      >
        <span>{item.name}</span>
      </div>
    )
  })

    const orderLines = useMemo(
    () => list.map(order => (
      <OrderLine
        key={order.id}
        order={order}
        editSuccess={modalEditSuccessToggle}
        copySuccess={modalCopySuccessToggle}
      />
    )),
    [list]
  )

  const dataTemplate = !isLoading && totalCount > 0 &&
    <div className={classes.data}>
      {windowSize.width >= 1920 &&
        <div className={classes.data_header}>
          {headerFieldsTemplate}
        </div>
      }
      {orderLines}
    </div>

  const modalUpdateSuccess = modalEditSuccessShown &&
    <ModalSuccess
      close={() => modalEditSuccessToggle(false)}
      title={"Заявка обновлена!"}
    />

  const modalCopySuccess = modalCopySuccessShown &&
    <ModalSuccess
      close={() => modalCopySuccessToggle(false)}
      title={"Копия заявки сохранена!"}
    />

  const cls = [classes.wrap]

  if (className)
    cls.push(className)

  return (
    <div className={cls.join(" ")}>
      <div className={classes.content}>
        {isLoading && <Loading/>}
        {dataTemplate}
      </div>
      <div className={classes.bottom}>
        <Pagination
          onPageChange={pageChangeHandler}
          pageRangeDisplayed={5}
          pageCount={pages}
          forcePage={currentPage - 1}
        />
      </div>
      {modalUpdateSuccess}
      {modalCopySuccess}
    </div>
  )
}

export default OrderList